import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { theme } from 'components/Theme/';
import React from 'react';
import { connect } from 'react-redux';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  handleChangeAccount: any;
  accountDefault: any;
  listAccounts: any;
  toggleChangeAccount: any;
}

interface IStates {
  selectedAccount: any;
}

class AccountList extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedAccount: this.props.accountDefault,
    };
  }

  handleChangeAccount = (event: any) => {
    this.setState({
      selectedAccount: JSON.parse(event.target.value),
    });
  };

  render() {
    const { listAccounts } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={0} className='transacation-list__accounts'>
          <Grid item xs={12}>
            <div className='my-title'>
              <h2>Alteração de conta bancária.</h2>
            </div>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label='Selecione a conta que deseja transferir:'
              id='account'
              select
              fullWidth
              value={JSON.stringify(this.state.selectedAccount)}
              onChange={this.handleChangeAccount}
              InputProps={{
                disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              {listAccounts &&
                !listAccounts.isFetching &&
                listAccounts.length > 0 &&
                listAccounts.map((account: any) => {
                  return (
                    <MenuItem value={JSON.stringify(account)} key={'acc-' + account.id}>
                      Banco: {account.bank_id}, Ag: {account.agency}-{account.agency_digit}, Conta: {account.account}-{account.account_digit},{' '}
                      {account.type}
                    </MenuItem>
                  );
                })}
            </TextField>

            <div className='m16' />

            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={this.props.toggleChangeAccount}>Voltar</Button>

              <Button
                onClick={() => this.props.handleChangeAccount(this.state.selectedAccount)}
                disabled={this.state.selectedAccount === this.props.accountDefault}
              >
                Alterar conta
              </Button>
            </div>
          </Grid>
        </Grid>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listAccounts: state.orbita.Profile.accounts,
  };
}

export default connect(mapStateToProps)(AccountList);
